import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-8f12ed28")

_pushScopeId("data-v-8f12ed28")
const _hoisted_1 = { class: "register-ic-card" }
const _hoisted_2 = { class: "text-2xl font-bold" }
const _hoisted_3 = { class: "background-member" }
const _hoisted_4 = { class: "text-gray-600" }
const _hoisted_5 = { class: "text-gray-600" }
const _hoisted_6 = { class: "flex mb-4 items-center" }
const _hoisted_7 = { class: "text-base mr-6 w-24" }
const _hoisted_8 = { class: "value-member" }
const _hoisted_9 = { class: "flex mb-4 items-center" }
const _hoisted_10 = { class: "text-base mr-6 w-24" }
const _hoisted_11 = { class: "value-member" }
const _hoisted_12 = { class: "flex mb-4 items-center" }
const _hoisted_13 = { class: "text-base mr-6 w-24" }
const _hoisted_14 = { class: "value-member" }
const _hoisted_15 = { class: "mb-6" }
const _hoisted_16 = { class: "" }
const _hoisted_17 = { class: "flex items-center w-full" }
const _hoisted_18 = { class: "flex-wrap flex" }
const _hoisted_19 = { class: "flex items-center mt-8" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_MultiSelect = _resolveComponent("MultiSelect")
  const _component_InputSearchEmployee = _resolveComponent("InputSearchEmployee")
  const _component_Checkbox = _resolveComponent("Checkbox")
  const _component_ApplicationSearchArea = _resolveComponent("ApplicationSearchArea")
  const _component_Table = _resolveComponent("Table")
  const _component_PlusIcon = _resolveComponent("PlusIcon")
  const _component_Button = _resolveComponent("Button")
  const _component_UploadSimpleIcon = _resolveComponent("UploadSimpleIcon")
  const _component_DownloadSimpleIcon = _resolveComponent("DownloadSimpleIcon")
  const _component_PopupRegisterCard = _resolveComponent("PopupRegisterCard")
  const _component_PopupDeleteRegister = _resolveComponent("PopupDeleteRegister")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, _toDisplayString(_ctx.t('icCardRegistration')), 1),
      _createVNode(_component_ApplicationSearchArea, {
        onClose: _ctx.closeSearchDetail,
        onReset: _ctx.resetSearchInput,
        onSearch: _ctx.handleSearchMembers
      }, {
        compact: _withId(() => [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.unitNames, (item) => {
            return (_openBlock(), _createBlock("div", {
              class: "mr-4 mt-1",
              key: item
            }, [
              _createVNode("div", _hoisted_3, [
                _createVNode("span", _hoisted_4, _toDisplayString(_ctx.t('affiliationDepartment')), 1),
                _createTextVNode(" : " + _toDisplayString(item), 1)
              ])
            ]))
          }), 128)),
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.paramsSearchRegister.pp_employee_ids, (item) => {
            return (_openBlock(), _createBlock("div", {
              class: "background-member mr-4 mt-1",
              key: item
            }, [
              _createVNode("span", _hoisted_5, _toDisplayString(_ctx.t('fullName')), 1),
              _createTextVNode(" : " + _toDisplayString(_ctx.getNameEmployee(item)), 1)
            ]))
          }), 128))
        ]),
        form: _withId(() => [
          _createVNode("div", _hoisted_6, [
            _createVNode("div", _hoisted_7, _toDisplayString(_ctx.t('affiliationDepartment')), 1),
            _createVNode("div", _hoisted_8, [
              _createVNode(_component_MultiSelect, {
                options: _ctx.unitList,
                itemValue: "unit_id",
                itemText: "unit_name",
                placeholder: _ctx.t('pleaseEnterTheDepartment'),
                modelValue: _ctx.paramsSearchRegister.unit_ids,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.paramsSearchRegister.unit_ids = $event))
              }, null, 8, ["options", "placeholder", "modelValue"])
            ])
          ]),
          _createVNode("div", _hoisted_9, [
            _createVNode("div", _hoisted_10, _toDisplayString(_ctx.t('workingStyle')), 1),
            _createVNode("div", _hoisted_11, [
              _createVNode(_component_MultiSelect, {
                placeholder: _ctx.t('pleaseEnterTheDepartment'),
                modelValue: _ctx.paramsSearchRegister.working_style_id,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.paramsSearchRegister.working_style_id = $event))
              }, null, 8, ["placeholder", "modelValue"])
            ])
          ]),
          _createVNode("div", _hoisted_12, [
            _createVNode("div", _hoisted_13, _toDisplayString(_ctx.t('fullName')), 1),
            _createVNode("div", _hoisted_14, [
              _createVNode(_component_InputSearchEmployee, {
                placeholder: _ctx.t('pleaseEnterTheDepartment'),
                modelValue: _ctx.paramsSearchRegister.pp_employee_ids,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.paramsSearchRegister.pp_employee_ids = $event))
              }, null, 8, ["placeholder", "modelValue"])
            ])
          ]),
          _createVNode("div", _hoisted_15, [
            _createVNode(_component_Checkbox, {
              modelValue: _ctx.paramsSearchRegister.ic_card,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.paramsSearchRegister.ic_card = $event)),
              label: _ctx.t('cardRegistration.icCardUnregisteredOnly'),
              "false-value": 1,
              "true-value": 0
            }, null, 8, ["modelValue", "label"])
          ])
        ]),
        _: 1
      }, 8, ["onClose", "onReset", "onSearch"]),
      _createVNode("div", _hoisted_16, [
        _createVNode(_component_Table, {
          headers: _ctx.registerHeader,
          data: _ctx.membersIcCard,
          class: "w-fit text-sm text-center"
        }, {
          ic_cards: _withId(({ item }) => [
            _createVNode("div", _hoisted_17, [
              _createVNode("div", _hoisted_18, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(item.ic_cards, (itemIcCard, index) => {
                  return (_openBlock(), _createBlock("div", {
                    class: "mr-2 bg-color-f8 rounded-50 py-1 pl-3 pr-2 flex items-center mb-1",
                    key: index
                  }, [
                    _createTextVNode(_toDisplayString(itemIcCard.card_id) + " ", 1),
                    _createVNode("span", {
                      onClick: ($event: any) => (_ctx.openPopupDeleteRegister(itemIcCard.card_id)),
                      class: "ml-2 cp-icon-close-circle text-lg cursor-pointer"
                    }, null, 8, ["onClick"])
                  ]))
                }), 128))
              ]),
              _createVNode("span", {
                onClick: ($event: any) => (_ctx.openPopupRegister(false, item)),
                class: "cp-icon-plus cursor-pointer text-4xl text-light-blue border-1 border-gray-300 rounded-full"
              }, null, 8, ["onClick"])
            ])
          ]),
          _: 1
        }, 8, ["headers", "data"])
      ]),
      _createVNode("div", _hoisted_19, [
        _createVNode(_component_Button, {
          class: "mr-4",
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.openPopupRegister(true)))
        }, {
          default: _withId(() => [
            _createVNode(_component_PlusIcon, { class: "mr-1 items-center" }),
            _createTextVNode(_toDisplayString(_ctx.t('approvedFlow.toRegister')), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_Button, {
          variant: "outline-primary",
          class: "mr-4"
        }, {
          default: _withId(() => [
            _createVNode(_component_UploadSimpleIcon, { class: "mr-1" }),
            _createTextVNode(" " + _toDisplayString(_ctx.t('cardRegistration.import')), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_Button, { variant: "outline-primary" }, {
          default: _withId(() => [
            _createVNode(_component_DownloadSimpleIcon, { class: "mr-1" }),
            _createTextVNode(" " + _toDisplayString(_ctx.t('export')), 1)
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode(_component_PopupRegisterCard, {
      modelValue: _ctx.isShowPopupRegister,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.isShowPopupRegister = $event)),
      onOnClose: _ctx.closePopupRegister,
      onOnSubmit: _ctx.handleSubmitIcCardNumber,
      isHandInputCardNumber: _ctx.isHandInputCardNumber,
      infoEmployee: _ctx.infoEmployee
    }, null, 8, ["modelValue", "onOnClose", "onOnSubmit", "isHandInputCardNumber", "infoEmployee"]),
    _createVNode(_component_PopupDeleteRegister, {
      modelValue: _ctx.isShowPopupDeleteRegister,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.isShowPopupDeleteRegister = $event)),
      onOnClose: _ctx.closePopupDeleteRegister,
      onOnDelete: _ctx.deleteIcCardNumber
    }, null, 8, ["modelValue", "onOnClose", "onOnDelete"])
  ], 64))
})